/* Smamblybite Ratgeber – Inhaltsverzeichnis und interaktive Rechner.
 * Gepflegt im Repo smamblybite-marketing-api. Rechner werden im Artikeltext per
 * <div class="smb-tool" data-smb-tool="NAME"></div> eingebunden. */
(function () {
  'use strict';

  var fmt = function (value, digits) {
    return new Intl.NumberFormat('de-DE', { maximumFractionDigits: digits || 0 }).format(value);
  };

  function slugify(text) {
    return text
      .toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function buildToc(article) {
    var nav = article.querySelector('[data-smb-toc-target]');
    var headings = Array.prototype.filter.call(
      article.querySelectorAll('.smb-prose h2'),
      function (h) { return !h.closest('.smb-sources'); }
    );
    if (!nav || !article.hasAttribute('data-smb-toc') || headings.length < 3) return;
    var list = nav.querySelector('ol');
    var used = {};
    var links = headings.map(function (heading) {
      var id = heading.id || slugify(heading.textContent) || 'abschnitt';
      while (used[id]) id += '-2';
      used[id] = true;
      heading.id = id;
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + id;
      link.textContent = heading.textContent;
      item.appendChild(link);
      list.appendChild(item);
      return link;
    });
    nav.hidden = false;

    // Aktuellen Abschnitt im Inhaltsverzeichnis markieren
    if (!('IntersectionObserver' in window)) return;
    var visible = {};
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { visible[entry.target.id] = entry.isIntersecting; });
      var current = null;
      headings.forEach(function (h) { if (h.getBoundingClientRect().top < window.innerHeight * 0.35) current = h.id; });
      links.forEach(function (link) { link.classList.toggle('is-active', link.hash === '#' + current); });
    }, { rootMargin: '0px 0px -60% 0px' });
    headings.forEach(function (h) { observer.observe(h); });
  }

  function field(id, label, html) {
    return '<div><label for="' + id + '">' + label + '</label>' + html + '</div>';
  }

  function number(id, value, min, max, step) {
    return '<input type="number" inputmode="decimal" id="' + id + '" value="' + value +
      '" min="' + min + '" max="' + max + '" step="' + (step || 1) + '">';
  }

  function select(id, options) {
    return '<select id="' + id + '">' + options.map(function (o) {
      return '<option value="' + o[0] + '"' + (o[2] ? ' selected' : '') + '>' + o[1] + '</option>';
    }).join('') + '</select>';
  }

  // 1 g Zucker = 4 kcal; ein Zuckerwürfel wiegt ca. 3 g.
  var SUGAR_CUBE_G = 3;

  var TOOLS = {
    // WHO (2015): freier Zucker < 10 % der Energiezufuhr, idealerweise < 5 %.
    'zucker-tagesbedarf': {
      title: 'Zucker-Rechner: Wie viel Zucker pro Tag?',
      form: function (p) {
        return field(p + 'kcal', 'Dein Kalorienbedarf pro Tag (kcal)', number(p + 'kcal', 2000, 800, 6000, 50));
      },
      calc: function (get) {
        var kcal = get('kcal');
        var max = (kcal * 0.10) / 4;
        var ideal = (kcal * 0.05) / 4;
        return 'Höchstens <strong>' + fmt(max) + ' g</strong> freier Zucker pro Tag (≈ ' +
          fmt(max / SUGAR_CUBE_G) + ' Zuckerwürfel), idealerweise unter <strong>' + fmt(ideal) +
          ' g</strong> (≈ ' + fmt(ideal / SUGAR_CUBE_G) + ' Würfel).';
      },
      note: 'Grundlage: WHO-Empfehlung (2015) – freier Zucker unter 10 %, besser unter 5 % der täglichen Energiezufuhr. Allgemeine Orientierung, keine individuelle Ernährungsberatung.'
    },

    'zuckerwuerfel': {
      title: 'Zuckerwürfel-Rechner',
      form: function (p) {
        return field(p + 'g', 'Zucker in Gramm', number(p + 'g', 25, 0, 1000, 0.5));
      },
      calc: function (get) {
        return '<strong>' + fmt(get('g'), 0) + ' g</strong> Zucker entsprechen etwa <strong>' +
          fmt(get('g') / SUGAR_CUBE_G, 1) + ' Zuckerwürfeln</strong>.';
      },
      note: 'Annahme: ein Zuckerwürfel wiegt ca. 3 g.'
    },

    // 1 KE = 10 g Kohlenhydrate, 1 BE = 12 g Kohlenhydrate
    'ke-rechner': {
      title: 'KE/BE-Rechner',
      form: function (p) {
        return field(p + 'carbs', 'Kohlenhydrate pro 100 g (laut Verpackung)', number(p + 'carbs', 60, 0, 100, 0.1)) +
          field(p + 'portion', 'Portion in Gramm', number(p + 'portion', 45, 1, 2000));
      },
      calc: function (get) {
        var carbs = get('carbs') * get('portion') / 100;
        return 'Die Portion enthält <strong>' + fmt(carbs, 1) + ' g Kohlenhydrate</strong> = <strong>' +
          fmt(carbs / 10, 1) + ' KE</strong> bzw. ' + fmt(carbs / 12, 1) + ' BE.';
      },
      note: '1 KE (Kohlenhydrateinheit) = 10 g, 1 BE (Broteinheit) = 12 g Kohlenhydrate. Bei Diabetes bitte die Therapie immer mit dem Diabetes-Team abstimmen.'
    },

    // Mifflin-St Jeor (Grundumsatz) × PAL (DGE)
    'kalorienbedarf': {
      title: 'Kalorienbedarf-Rechner',
      form: function (p) {
        return field(p + 'sex', 'Geschlecht', select(p + 'sex', [['f', 'weiblich', true], ['m', 'männlich']])) +
          field(p + 'age', 'Alter', number(p + 'age', 35, 15, 100)) +
          field(p + 'weight', 'Gewicht (kg)', number(p + 'weight', 70, 30, 250)) +
          field(p + 'height', 'Größe (cm)', number(p + 'height', 170, 120, 230)) +
          field(p + 'pal', 'Aktivität', select(p + 'pal', [
            ['1.4', 'überwiegend sitzend'],
            ['1.6', 'sitzend, etwas Bewegung', true],
            ['1.8', 'viel stehend/gehend oder regelmäßiger Sport'],
            ['2.0', 'körperlich sehr aktiv']
          ]));
      },
      calc: function (get, raw) {
        var base = 10 * get('weight') + 6.25 * get('height') - 5 * get('age') + (raw('sex') === 'm' ? 5 : -161);
        var total = base * get('pal');
        return 'Grundumsatz ca. <strong>' + fmt(base, 0) + ' kcal</strong>, Gesamtbedarf ca. <strong>' +
          fmt(total, 0) + ' kcal</strong> pro Tag.';
      },
      note: 'Schätzung nach Mifflin-St-Jeor-Formel und PAL-Werten der DGE. Der tatsächliche Bedarf kann abweichen.'
    }
  };

  function mountTool(el, index) {
    var tool = TOOLS[el.getAttribute('data-smb-tool')];
    if (!tool) return;
    var prefix = 'smb-tool-' + index + '-';
    el.innerHTML = '<p class="smb-tool__title">' + tool.title + '</p>' +
      '<div class="smb-tool__grid">' + tool.form(prefix) + '</div>' +
      '<div class="smb-tool__result" aria-live="polite"></div>' +
      '<p class="smb-tool__note">' + tool.note + '</p>';
    var raw = function (name) { return el.querySelector('#' + prefix + name).value; };
    var get = function (name) { return parseFloat(String(raw(name)).replace(',', '.')) || 0; };
    var result = el.querySelector('.smb-tool__result');
    var update = function () { result.innerHTML = tool.calc(get, raw); };
    el.addEventListener('input', update);
    el.addEventListener('change', update);
    update();
  }

  function init() {
    document.querySelectorAll('[data-smb-article]').forEach(buildToc);
    document.querySelectorAll('[data-smb-tool]').forEach(mountTool);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
